import { z } from 'zod';
import { eventSchema } from './envelope';

export const NOTIFICATIONS_DELIVERY_FAILED_V1 = 'notifications.delivery.failed.v1' as const;

/**
 * Afleveren is misgegaan, geteld per batch en niet per persoon.
 *
 * Een pushdienst die er even uit ligt, levert anders vijfduizend events op voor één storing —
 * en dan is de storing niet meer te zien tussen de ruis. Dit event bestaat om te kunnen
 * opmerken dát het misgaat: een monitor kijkt naar het aantal, niet naar wie.
 */
export const deliveryFailedV1Schema = eventSchema({
  channel: z.enum(['push', 'email']),
  refModule: z.string(),
  refId: z.guid(),
  failed: z.number().int(),
  /** Hoeveel abonnementen er zijn uitgeschakeld omdat de pushdienst ze niet meer kent. */
  disabled: z.number().int(),
  /** De eerste fout, als voorbeeld. Geen lijst: dit is een signaal, geen logboek. */
  sample: z.string().nullable(),
});

export type DeliveryFailedV1 = z.infer<typeof deliveryFailedV1Schema>;

export const notificationsEventCatalog = {
  [NOTIFICATIONS_DELIVERY_FAILED_V1]: deliveryFailedV1Schema,
} as const;
